// components/ScrollToTopButton.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const TopButton = styled.button`
  display: ${props => props.visible ? 'block' : 'none'};
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99;
  border: none;
  outline: none;
  background-color: #e0a800;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 10px;
  width: 50px;
  height: 50px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #c99700;
  }
  
  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 15px solid white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    
    window.addEventListener('scroll', toggleVisibility);
    
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <TopButton
      visible={visible}
      onClick={scrollToTop}
      title="Nach oben"
    />
  );
}

export default ScrollToTopButton;